<template>
  <div>
    <div class="mb-3">
      <label for="location-type" class="form-label">{{ $t('po_lc_lb_location_type') }}*</label>
      <v-select :options="[{label: 'Restaurant', code: 'restaurant'}, {label: 'Hotel', code: 'hotel'}]" :reduce="locationType => locationType.code" v-model="location.locationType" name="locationType" :clearable="false"></v-select>
    </div>
    <div class="mb-3">
      <label for="name" class="form-label">{{ $t('po_lc_lb_name') }}*</label>
      <input id="name" name="name" type="text" class="form-control" :class="{ 'is-invalid': v$.location.name.$error }"
        :placeholder="$t('po_lc_tx_name')" ref="name" v-model="location.name">
      <div class="invalid-feedback">{{ v$.location.name.$errors[0]?.$message }}</div>
    </div>
    <div class="mb-3">
      <label for="description" class="form-label">{{ $t('po_lc_lb_description') }}</label>
      <input id="description" name="description" type="text" class="form-control" :class="{ 'is-invalid': v$.location.description.$error }"
             :placeholder="$t('po_lc_tx_description')" ref="description" v-model="location.description">
      <div class="invalid-feedback">{{ v$.location.description.$errors[0]?.$message }}</div>
    </div>
    <div class="mb-3">
      <label for="email" class="form-label">{{ $t('po_lc_lb_contact-email') }}{{ emailRequired ? '*' : '' }}</label>
      <input id="email" name="email" type="text" class="form-control" :class="{ 'is-invalid': v$.location.email.$error }"
        :placeholder="$t('po_lc_tx_contact_email')" ref="password" v-model="location.email">
      <div class="invalid-feedback">{{ v$.location.email.$errors[0]?.$message }}</div>
    </div>
    <addressForm v-model="location.address" :textPostFix="$t('po_lc_lb_address_postfix')"></addressForm>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, email } from '@/config/i18n-validators'
import addressForm from '@/components/common/AddressForm.vue'

export default {
  props: {
    modelValue: Object,
    emailRequired: Boolean
  },
  components: {
    addressForm
  },
  setup () {
    return {
      v$: useVuelidate({ $autoDirty: true })
    }
  },
  validations () {
    return {
      location: {
        locationType: { required },
        name: { required },
        description: { },
        email: {
          required: this.emailRequired ? required : { },
          email
        }
      }
    }
  },
  computed: {
    location: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit('update:modelValue', val)
      }
    }
  }
}
</script>
